
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {

    display: flex;

    flex-direction: row
}

.footer-logos {

    display: flex;

    flex-wrap: wrap;

    place-content: center;

    gap: 2rem;

    fill: var(--neutral-white);

    color: var(--neutral-white)
}

@media (min-width: 1024px) {

    .footer-logos {

        place-content: start
    }
}
`;